<app-hero
    title="Términos y condiciones de uso y navegación del sitio SALDOAR"
    imageUrl="assets/images/terms/tyc.svg"
    [imageSettings]="{width: 750, height: 750}"></app-hero>

<app-info-block *ngFor="let info of termsAndConditions"
    [titleBlock]="info.title"
    [content]="info.content"></app-info-block>

<app-info-block>
    <p><small>Dirección de defensa al consumidor de la Ciudad de Buenos Aires:
        <a class="rs-link" href="https://www.buenosaires.gob.ar/defensaconsumidor/direccion-general">Dirección General de Defensa y
            Protección al Consumidor</a></small></p>
    <p><small>Para contactar a la Dirección Nacional de Protección de Datos Personales: Sarmiento 1118, 5º piso
        (C1041AAX). Tel: 4383-8510/12/13/15.
        <a class="rs-link" href="https://www.argentina.gob.ar/aaip/datospersonales">AAIP Datos Personales</a>
        - infodnpdp@just.gov.ar </small></p>
</app-info-block>
